import { render, staticRenderFns } from "./company-invoices.vue?vue&type=template&id=4f4f60c4&scoped=true&"
import script from "./company-invoices.ts?vue&type=script&lang=ts&"
export * from "./company-invoices.ts?vue&type=script&lang=ts&"
import style0 from "./company-invoices.vue?vue&type=style&index=0&id=4f4f60c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4f60c4",
  null
  
)

export default component.exports